// mobile navigatino
let toggeBtn = document.getElementById("nav_togge_btn");
let mobileNav = document.querySelector(".nav_menu");
toggeBtn.addEventListener("click", () => {
  mobileNav.classList.toggle("show");
});

let mybody = document.querySelector("body");
let navbutton = document.getElementById("nav_togge_btn");
navbutton.addEventListener("click", () => {
  if (navbutton.classList.contains("opened")) {
    mybody.classList.add("bodystyl");
  } else {
    mybody.classList.remove("bodystyl");
  }
});

// Select elements
const headerTop = document.querySelector('.hedr_top');
const header = document.querySelector('.hedr');

// Add scroll event listener
window.addEventListener('scroll', () => {
  const scrollPosition = window.scrollY;

  // Hide hedr_top after 50px of scrolling
  if (scrollPosition > 100) {
    headerTop.classList.add('hide');
    header.classList.add('sticky');
  } else {
    headerTop.classList.remove('hide');
    header.classList.remove('sticky');
  }
});

const searchIcon = document.getElementById("search-icon");
const searchBar = document.getElementById("search-bar");
const closeSearchBar = document.getElementById("search-bar-close");

// Show the search bar when the search icon is clicked
searchIcon.addEventListener("click", () => {
  searchBar.classList.toggle("active");
});

// Hide the search bar when the close icon is clicked
closeSearchBar.addEventListener("click", () => {
  searchBar.classList.remove("active");
});

$(".client-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1,
      },
    },
  ],
});

// Aos animation
AOS.init({
  duration: 1000,
  once: true,
  // disable: function () {
  //   let maxWidth = 767;
  //   return window.innerWidth < maxWidth;
  // },
});
/////////////add active class///////////////////////////////
document.addEventListener("DOMContentLoaded", function() {
      // Get the current URL
      const currentUrl = window.location.pathname;

      // Get all navigation links in both nav_link and nav_footer classes
      const navLinks = document.querySelectorAll('.nav_link, .nav_footer');

      // Loop through each nav link
      navLinks.forEach(link => {
         // Check if the href of the link matches the current URL
         if (link.getAttribute('href') === currentUrl) {
            // Add the 'active' class to the link if it matches
            link.classList.add('active');
         }
      });
   });

////////////////////
class HelloWorld extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `<p>Hello, World!</p>`;
  }
}

// Define the custom element
customElements.define('hello-world', HelloWorld);